import { NavLink, useNavigate } from "react-router-dom";
import SEO from "../SEO";
import { seoConfig } from "../config/seoConfig";
import { useState, useEffect } from "react";
import "../Component2/css/Signin.css";
import logo from "../Component2/Image/logo2.png";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import { BASE_URL } from "../config/constants";
import { saveFcmToken } from "./saveFcmToken";
import ReCAPTCHA from "react-google-recaptcha";
import SignupVideoModal from "./SignupVideoModal";
import { parseApiResponse } from "../config/parseApiResponse";

function Signin() {
  const navigate = useNavigate();

  const [successMsg, setSuccessMsg] = useState("");
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ FIX 1: activeRole state
  const [activeRole, setActiveRole] = useState("candidate");
  useEffect(() => {
    if (activeRole === "candidate") {
      localStorage.removeItem("auth");
      localStorage.removeItem("employer");
    } else {
      localStorage.removeItem("candidate");
    }
  }, [activeRole]);

  /* ================= FORMik ================= */
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Minimum 6 characters")
        .required("Password is required"),
    }),

    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      try {
        let url = "";
        let payload = {};

        if (activeRole === "candidate") {
          url = `${BASE_URL}candidate/signin/tbl_candidate`;
          payload = {
            can_email: values.email,
            can_password: values.password,
          };
        } else {
          url = `${BASE_URL}employer/signin/tbl_employer`;
          payload = {
            emp_email: values.email,
            emp_password: values.password,
          };
        }

        let response = await axios.post(url, payload);
        // let data = response.data;

        let data = parseApiResponse(response);

        /* ==============================
       ✅ OTP REQUIRED (FIXED)
    ============================== */
        if (data.otp_required === true) {
          toast.error(data.message || "OTP verification required");

          localStorage.setItem(
            "signupTempData",
            JSON.stringify({
              role: activeRole,
              data: data.data,
              createdAt: Date.now(),
            }),
          );

          localStorage.setItem(
            "verifyUser",
            JSON.stringify({
              email: data.email || values.email,
              role: activeRole,
              mobile: data.mobile,
            }),
          );

          navigate("/verify");
          return;
        }

        /* ==============================
       IF NOT EMPLOYER → TRY STAFF
    ============================== */
        if (Number(data.loginstatus) === 0) {
          response = await axios.post(
            `${BASE_URL}employer/signinstaff/tbl_staff`,
            {
              staff_email: values.email,
              staff_password: values.password,
            },
          );

          data = parseApiResponse(response);
        }

        if (data.status === true) {
          toast.success(data.message || "Login successful!");

          if (activeRole === "candidate") {
            localStorage.setItem("candidate", JSON.stringify(data.data));

            if (data.data?.can_id) {
              saveFcmToken(data.data.can_id);
            }

            navigate("/profile");
          } else {
            // ✅ STAFF LOGIN
            if (data.data?.staff_id) {
              localStorage.setItem(
                "auth",
                JSON.stringify({
                  role: 200,
                  staff_id: data.data.staff_id,
                  staff_email: data.data.staff_email,
                  menu_ids: data.menu_ids || [],
                }),
              );

              localStorage.setItem("staff", JSON.stringify(data.data));
              navigate("/dashboard");
            } else {
              // EMPLOYER LOGIN
              localStorage.setItem(
                "auth",
                JSON.stringify({
                  role: 100,
                  emp_id: data.data.emp_id,
                  emp_name: data.data.emp_name,
                  emp_email: data.data.emp_email,
                  emp_mobile: data.data.emp_mobile,
                  emp_companyname: data.data.emp_companyname,
                  profile_completed: Number(data.data.profile_completed) || 0, // ✅ ADD THIS
                }),
              );

              localStorage.setItem("employer", JSON.stringify(data.data));
              navigate("/emp-profile");
            }
          }

          resetForm();
          return;
        }

        /* ==============================
       ✅ PAYMENT REQUIRED
    ============================== */
        if (data.payment_required === true) {
          toast.error(
            data.message || "Payment pending. Please complete payment.",
          );

          localStorage.setItem(
            "signupTempData",
            JSON.stringify({
              role: activeRole,
              data: data.data,
              createdAt: Date.now(),
            }),
          );

          localStorage.setItem(
            "paymentUser",
            JSON.stringify({
              email: values.email,
              role: activeRole.toLowerCase(),
            }),
          );

          navigate("/payment");
          return;
        }

        /* ==============================
       ❌ NORMAL FAIL
    ============================== */
        toast.error(data.message || "Login failed");
      } catch (error) {
        const errData = error.response?.data;

        console.log("ERROR RESPONSE:", errData);

        /* ==============================
       OTP REQUIRED (if backend sends 403)
    ============================== */
        if (errData?.otp_required === true) {
          toast.error(errData.message || "OTP verification required");

          localStorage.setItem(
            "signupTempData",
            JSON.stringify({
              role: activeRole,
              data: errData.data,
              createdAt: Date.now(),
            }),
          );

          localStorage.setItem(
            "verifyUser",
            JSON.stringify({
              email: errData.email || values.email,
              role: activeRole,
              mobile: errData.mobile,
            }),
          );

          navigate("/verify");
          return;
        }

        /* ==============================
       PAYMENT REQUIRED
    ============================== */
        if (errData?.payment_required === true) {
          toast.error(
            errData.message || "Payment pending. Please complete payment.",
          );

          localStorage.setItem(
            "signupTempData",
            JSON.stringify({
              role: activeRole,
              data: errData.data,
              createdAt: Date.now(),
            }),
          );

          localStorage.setItem(
            "paymentUser",
            JSON.stringify({
              email: values.email,
              role: activeRole.toLowerCase(),
              for: "AccountCreate",
              returnTo:
                activeRole === "candidate" ? "/profile" : "/emp-profile",
            }),
          );

          navigate("/payment");
          return;
        }

        toast.error(errData?.message || "Invalid email or password");
      } finally {
        setLoading(false);
      }
    },
  });

  // ✅ FIX 2: handleSubmit define
  const handleSubmit = formik.handleSubmit;

  const [showModal, setShowModal] = useState(false);

  const handleSignupClick = (e) => {
    e.preventDefault(); // 🔒 stop direct navigation
    setShowModal(true);
  };

  return (
    <>
      <SEO
        title={seoConfig.signin.title}
        description={seoConfig.signin.description}
      />
      {/* TOAST */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        theme="colored"
      />
      <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
        <div
          className="row g-0 shadow-lg rounded-4 overflow-hidden bg-white"
          style={{ maxWidth: "1000px" }}
        >
          {/* LEFT SIDE BRAND PANEL */}
          <div className="col-lg-6 d-none d-lg-flex flex-column justify-content-between text-white p-4 brand-panel">
            <div>
              <h2 className="fw-bold">Pharma Jobs</h2>
              <h4 className="fw-semibold">
                Your next hire is{" "}
                <span style={{ color: "#22f869" }}>already here.</span>
              </h4>
              <p className="small opacity-75">
                Smart matching for fast teams & ambitious job seekers.
              </p>

              <span className="badge bg-primary rounded-pill p-3 mb-2 border-0">
                10k+ Active Candidates
              </span>
              <br />
              <span className="badge bg-success text-dark rounded-pill p-3 border-0">
                Trusted by 250+ companies
              </span>
            </div>

            <div className="bg-dark bg-opacity-50 p-3 rounded-3">
              <small className="text-uppercase opacity-75">Highlight</small>
              <h6 className="fw-semibold">One login for all your hiring</h6>
              <p className="small opacity-75">
                Track candidates & manage interviews from one dashboard.
              </p>
            </div>
          </div>

          {/* RIGHT LOGIN FORM */}
          <div className="col-lg-6 p-4 p-md-5">
            <div className="text-center">
              <NavLink to="/">
                <img
                  src={logo}
                  style={{
                    width: "200px",
                    height: "70px",
                    margin: "-15px 0 10px 0",
                  }}
                  alt="logo"
                />
              </NavLink>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h2 className="fw-semibold">Welcome back</h2>
                <p className="text-muted">Login to Pharma Jobs.</p>
              </div>
              <NavLink
                to="/signup"
                onClick={handleSignupClick}
                className="btn btn-sm btn-outline-auth"
              >
                <b>New Register</b>
              </NavLink>
            </div>

            <SignupVideoModal
              show={showModal}
              onClose={() => setShowModal(false)}
            />

            {apiError && (
              <div className="alert alert-danger py-2">{apiError}</div>
            )}

            {successMsg && (
              <div className="alert alert-success py-2">{successMsg}</div>
            )}

            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="mb-3">
                <label className="fw-bold">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Enter Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              {/* PASSWORD */}
              <div className="mb-2">
                <label className="fw-bold d-flex justify-content-between">
                  Password
                  <NavLink to="/forgot" className="text-decoration-none small">
                    Forgot?
                  </NavLink>
                </label>

                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder="Enter Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.password}
                  </div>
                )}
              </div>

              {/* ROLE */}
              <div className="mt-3 mb-4">
                <label className="small fw-medium d-block">Login as</label>

                <div className="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className={`role-pill ${
                      activeRole === "candidate" ? "active" : ""
                    }`}
                    onClick={() => setActiveRole("candidate")}
                  >
                    Candidate
                  </button>

                  <button
                    type="button"
                    className={`role-pill ${
                      activeRole === "employer" ? "active" : ""
                    }`}
                    onClick={() => setActiveRole("employer")}
                  >
                    Employer / Recruiter
                  </button>
                </div>
              </div>

              {/* SUBMIT */}
              <button
                type="submit"
                className="btn btn-primary-auth w-100m "
                disabled={loading}
              >
                {loading
                  ? activeRole === "candidate"
                    ? "Logging in as Candidate..."
                    : "Logging in as Employer..."
                  : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signin;
